import React from 'react'
import PropTypes from 'prop-types'
import { View } from 'react-native'
import { VFText, VFInput, VFDropdown } from '@vfgroup-oneplatform/foundation/Components'

import styles from './PesonalForm.Styles'


// const IdTypes = [
// 	{
// 		id: 0,
// 		value: 'individual',
// 		label: 'renewals_manual_personal_id'
// 	},
// 	{
// 		id: 1,
// 		value: 'organization',
// 		label: 'renewals_manual_nipt'
// 	},
// ]

function PersonalForm({
	inputRef,
	accountInfo,
	checkId,
	idError,
	isNameError,
	checkName,
	isSurnameError,
	checkSurname,
	setNameError,
	setSurnameError,
	setIdError,
	isPurchase,
	isPurchaseID,
	theme,
}) {
	if ((isPurchase && isPurchaseID) || !isPurchase) {
		return (<View>
			{/* <VFDropdown
				items={IdTypes}
				placeholder={{ label: IdTypes.find(el => el.value === accountInfo?.idType)?.label || 'renewals_id_type' }}
				isArrowShown={true}
				style={styles.dropdown}
				onValueChange={(type) => accountInfo?.setIdType(type)}
				labelStyle={[styles.inputText, { color: accountInfo?.idType ? theme.colors.textColor : theme.colors.textColorTwo }]}
			/> */}
			<VFInput
				fieldRef={ref => {
					inputRef.current = ref
				}}
				label='renewals_id_personal_number_label'
				value={accountInfo?.id}
				onChangeText={text => accountInfo?.setIdNumber?.(text)}
				containerStyle={styles.inputContainer}
				labelTextStyle={styles.inputText}
				helperTextWrapperStyle={styles.helperTextWrapperStyle}
				style={styles.inputText}
				tintColor={theme.colors.textInput.default.tintColor}
				onBlur={checkId}
				onFocus={() => setIdError(false)}
				showHelperText={idError}
				helperTextColor={theme.colors.textInput.error.baseColor}
				helperText="renewals_id_wrong_personal_number_format"
				baseColor={idError ? theme.colors.textInput.error.baseColor : theme.colors.textInput.default.baseColor}
				autoCapitalize="characters"
				textColor={theme.colors.textColor}
			/>
		</View>)
	}
	return (
		<>
			<View style={styles.inputRow}>
				<VFInput
					fieldRef={ref => {
						inputRef.current = ref
					}}
					label="renewals_id_name_label"
					value={accountInfo?.name}
					onChangeText={text => accountInfo?.setName?.(text)}
					containerStyle={[styles.inputContainer, styles.rightSpacing]}
					labelTextStyle={styles.inputText}
					helperTextWrapperStyle={styles.helperTextWrapperStyle}
					style={styles.inputText}
					tintColor={theme.colors.textInput.default.tintColor}
					onBlur={checkName}
					onFocus={() => setNameError(false)}
					showHelperText={isNameError}
					helperTextColor={theme.colors.textInput.error.baseColor}
					helperText="renewals_id_wrong_name_format"
					baseColor={isNameError ? theme.colors.textInput.error.baseColor : theme.colors.textInput.default.baseColor}
					textColor={theme.colors.textColor}
				/>
				<VFInput
					fieldRef={ref => {
						inputRef.current = ref
					}}
					label="renewals_id_surname_label"
					value={accountInfo?.surname}
					onChangeText={text => accountInfo?.setSurname?.(text)}
					containerStyle={styles.inputContainer}
					labelTextStyle={styles.inputText}
					helperTextWrapperStyle={styles.helperTextWrapperStyle}
					style={styles.inputText}
					tintColor={theme.colors.textInput.default.tintColor}
					onBlur={checkSurname}
					onFocus={() => setSurnameError(false)}
					showHelperText={isSurnameError}
					helperTextColor={theme.colors.textInput.error.baseColor}
					helperText="renewals_id_wrong_surname_format"
					baseColor={isSurnameError ? theme.colors.textInput.error.baseColor : theme.colors.textInput.default.baseColor}
					textColor={theme.colors.textColor}
				/>
			</View>
			<VFInput
				fieldRef={ref => {
					inputRef.current = ref
				}}
				label="renewals_id_personal_number_label"
				value={accountInfo?.id}
				onChangeText={text => accountInfo?.setIdNumber?.(text)}
				containerStyle={styles.inputContainer}
				labelTextStyle={styles.inputText}
				helperTextWrapperStyle={styles.helperTextWrapperStyle}
				style={styles.inputText}
				tintColor={theme.colors.textInput.default.tintColor}
				onBlur={checkId}
				onFocus={() => setIdError(false)}
				showHelperText={idError}
				helperTextColor={theme.colors.textInput.error.baseColor}
				helperText="renewals_id_wrong_personal_number_format"
				baseColor={idError ? theme.colors.textInput.error.baseColor : theme.colors.textInput.default.baseColor}
				textColor={theme.colors.textColor}
				autoCapitalize="characters"
			/>
			<VFDropdown
				items={accountInfo?.issuingCountryOptions}
				showArrow={true}
				placeholder={{ label: 'renewals_id_issuing_country_label' }}
				style={styles.dropdown}
				onValueChange={(text) => accountInfo?.setIssuingCountry?.(text)}
				labelStyle={[styles.inputText, { color: accountInfo?.issuingCountry ? theme.colors.textColor : theme.colors.textColorTwo }]}
				containerStyle={styles.identificationDropDown}
				zIndex={0}
				optionsStyle={{ height: 400 }}
			/>
			<View style={styles.inputRowId}>
				<View style={styles.rowDropDownWrapper}>
					<VFDropdown
						items={accountInfo?.monthOptions}
						showArrow={true}
						placeholder={{ label: 'renewals_id_month_label' }}
						style={styles.dropdown}
						onValueChange={(text) => accountInfo?.setMonth?.(text)}
						labelStyle={[styles.inputText, { color: accountInfo?.month ? theme.colors.textColor : theme.colors.textColorTwo }]}
						containerStyle={styles.rightSpacing}
						position="relative"
						zIndex={30}
						flatListProps={{ nestedScrollEnabled: true }}
						optionsStyle={{ height: 250 }}
					/>
					<View style={styles.helperTextContainerStyle}>
						<VFText
							i18nKey="renewals_expiration_month_label"
							style={styles.helperTextStyle(theme)}
							accessibilityRole="text"
						/>
					</View>
				</View>
				<View style={[styles.rowDropDownWrapper, { zIndex: 0 }]}>
					<VFDropdown
						items={accountInfo?.yearOptions}
						showArrow={true}
						placeholder={{ label: 'renewals_id_year_label' }}
						style={styles.dropdown}
						onValueChange={(text) => accountInfo?.setYear(text)}
						labelStyle={[styles.inputText, { color: accountInfo?.year ? theme.colors.textColor : theme.colors.textColorTwo }]}
						containerStyle={styles.rowDropDown}
						position="relative"
						zIndex={40}
						flatListProps={{ nestedScrollEnabled: true }}
						optionsStyle={{ height: 250 }}
					/>
					<View style={styles.helperTextContainerStyle}>
						<VFText
							i18nKey="renewals_expiration_year_label"
							style={styles.helperTextStyle(theme)}
							accessibilityRole="text"
						/>
					</View>
				</View>
			</View>
		</>
	)
}
PersonalForm.propTypes = {
	accountInfo: PropTypes.object,
	inputRef: PropTypes.object,
	offers: PropTypes.array,
	checkId: PropTypes.func,
	idError: PropTypes.bool,
	checkName: PropTypes.func,
	isNameError: PropTypes.bool,
	checkSurname: PropTypes.func,
	isSurnameError: PropTypes.bool,
	setNameError: PropTypes.func,
	setIdError: PropTypes.func,
	setSurnameError: PropTypes.func,
	isPurchase: PropTypes.bool,
	theme: PropTypes.bool,
}
export default PersonalForm
